import { render, staticRenderFns } from "./Collection2.vue?vue&type=template&id=5df73ff3&"
import script from "./Collection2.vue?vue&type=script&lang=js&"
export * from "./Collection2.vue?vue&type=script&lang=js&"
import style0 from "./Collection2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports